import React from 'react';
import InfoDriver from 'components/infoDriver';


export default function Info() {
  return (
    <InfoDriver/>
  );
}